import React from 'react';

import { Icon, Image } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { ResizeMode } from 'components/picture/types';
import { Box, BoxProps, Typography, withTypography } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$white,
    borderRadius: 12,
    overflow: 'hidden',
    paddingBottom: spacing.$6,
    width: '100%',
  },
  contentContainer: {
    paddingHorizontal: spacing.$6,
  },
  title: {
    marginVertical: spacing.$6,
  },
  itemsSection: {
    alignItems: 'center',
    width: '100%',
  },
  itemsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidth: 400,
    width: '100%',
  },
  itemContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemIconContainer: {
    alignItems: 'center',
    backgroundColor: primitive.$bbqBrown,
    borderRadius: 9999,
    height: spacing.$18,
    justifyContent: 'center',
    width: spacing.$18,
  },
  itemText: {
    marginBottom: 0,
    marginTop: spacing.$4,
  },
  sectionTitle: {
    marginBottom: 0,
    marginTop: spacing.$6,
  },
});

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const ContentContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.contentContainer, style] });

export const Title = withTypography({
  fontFamily: 'heading',
  fontSize: 'md',
  textAlign: 'center',
  style: styles.title,
});

export const ItemsSection = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.itemsSection, style] });

export const ItemsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.itemsContainer, style] });

export const ItemContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.itemContainer, style] });

export const ItemIconContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.itemIconContainer, style] });

export const StyledIcon = Icon.withConfig({
  size: '$8',
  color: primitive.$meltyYellow,
});

export const ItemText = ({
  style,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography>) => {
  const isMobile = useIsMobileBreakpoint();

  return React.createElement(Typography, {
    variant: 'headerThree',
    fontSize: isMobile ? 'xs' : 'sm',
    textAlign: 'center',
    ...props,
    style: [styles.itemText, style],
  });
};

export const StyledImage = Image.withConfig(() => {
  const isMobile = useIsMobileBreakpoint();

  return {
    resizeMode: ResizeMode.cover,
    height: isMobile ? '198px' : '341px',
  };
});

export const SectionTitle = withTypography({
  variant: 'headerThree',
  fontSize: 'xl',
  textAlign: 'center',
  style: styles.sectionTitle,
});
